import React from 'react';
import { WATERMARK_POSITION } from '../../../reducers/serviceSettings';

interface ColorAndPositionRowProps {
  colorValue: string;
  onColorChange: (color: string) => void;
  positionValue: string;
  onPositionChange: (position: string) => void;
}

const selectStyle: React.CSSProperties = {
  fontSize: 14,
  padding: '4px 12px',
  borderRadius: 4,
  border: '1px solid #bbb',
  background: '#fafafa',
};

const ColorAndPositionRow: React.FC<ColorAndPositionRowProps> = ({
  colorValue,
  onColorChange,
  positionValue,
  onPositionChange,
}) => (
  <div style={{ display: 'flex', gap: 16, marginBottom: 12, flexWrap: 'wrap' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <label style={{ color: '#444', fontSize: 14, whiteSpace: 'nowrap' }}>文字色：</label>
      <select value={colorValue} onChange={e => onColorChange(e.target.value)} style={selectStyle}>
        <option value="#ffffff">白色</option>
        <option value="#000000">黒色</option>
      </select>
    </div>
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <label style={{ color: '#444', fontSize: 14, whiteSpace: 'nowrap' }}>配置：</label>
      <select value={positionValue} onChange={e => onPositionChange(e.target.value)} style={selectStyle}>
        {WATERMARK_POSITION.map((pos) => (
          <option key={pos.value} value={pos.value}>{pos.label}</option>
        ))}
      </select>
    </div>
  </div>
);

export default ColorAndPositionRow;
